import HomeCtrl from "./HomeCtrl";
export default class SamoodpocetCtrl extends HomeCtrl {

  constructor(AuthService, KontaktService, OdberneMiestoService, SamoodpocetService, $state, $stateParams){
    super(AuthService, KontaktService, OdberneMiestoService, SamoodpocetService, $state, $stateParams);
    this.rk = false;
  }
}


// WEBPACK FOOTER //
// ./src/Home/SamoodpocetCtrl.js